import { useEffect, useRef } from "react";

import PageSeo from "@/components/PageSeo";
import ChecklistSection from "@/components/sections/ChecklistSection";
import CtaBannerSection from "@/components/sections/CtaBannerSection";
import FaqSection from "@/components/sections/FaqSection";
import FeatureListSection from "@/components/sections/FeatureListSection";
import HeroSection from "@/components/sections/HeroSection";
import PricingSection from "@/components/sections/PricingSection";
import ProductPreviewSection from "@/components/sections/ProductPreviewSection";
import ProfileSection from "@/components/sections/ProfileSection";
import StatementSection from "@/components/sections/StatementSection";
import { aiCareerAdvantagePageContent } from "@/content/pages/aiCareerAdvantagePage";
import { trackBundleViewContent } from "@/lib/conversionTracking";

const AiCareerAdvantagePage = () => {
  const hasTrackedViewContent = useRef(false);

  useEffect(() => {
    if (hasTrackedViewContent.current) {
      return;
    }

    hasTrackedViewContent.current = true;
    trackBundleViewContent();
  }, []);

  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={aiCareerAdvantagePageContent.seo} />
      <HeroSection
        content={aiCareerAdvantagePageContent.hero}
        checkoutProduct="bundle"
        dataTestId="bundle-hero"
      />
      <StatementSection content={aiCareerAdvantagePageContent.problemSection} dataTestId="bundle-problem" />
      <ChecklistSection
        content={aiCareerAdvantagePageContent.includedSection}
        dataTestId="bundle-included"
      />
      <FeatureListSection
        content={aiCareerAdvantagePageContent.benefitsSection}
        gridClassName="grid-cols-1 md:grid-cols-3"
        dataTestId="bundle-benefits"
      />
      <FeatureListSection
        content={aiCareerAdvantagePageContent.systemSection}
        gridClassName="grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
        className="bg-muted/50"
        dataTestId="bundle-system"
      />
      <ProductPreviewSection
        content={aiCareerAdvantagePageContent.previewSection}
        sectionId="inside"
        dataTestId="bundle-preview"
      />
      <CtaBannerSection content={aiCareerAdvantagePageContent.midPageCta} checkoutProduct="bundle" dataTestId="bundle-mid-cta" />
      <ChecklistSection content={aiCareerAdvantagePageContent.audienceSection} dataTestId="bundle-audience" />
      <ProfileSection content={aiCareerAdvantagePageContent.instructorSection} dataTestId="bundle-instructor" />
      <PricingSection
        content={aiCareerAdvantagePageContent.pricingSection}
        checkoutProduct="bundle"
        sectionId="pricing"
        dataTestId="bundle-pricing"
      />
      <FaqSection content={aiCareerAdvantagePageContent.faqSection} dataTestId="bundle-faq" />
      <CtaBannerSection content={aiCareerAdvantagePageContent.finalCta} checkoutProduct="bundle" dataTestId="bundle-final-cta" />
    </div>
  );
};

export default AiCareerAdvantagePage;
